import React, { useState, useEffect } from 'react';
import '../../../entrydoor.css';

const WinHinges = ({ value, onChange, id='WinHinges', label = 'Hinges', disabled = false }) => {
    const [selectedWinHinges, setSelectedWinHinges] = useState(value || "Left");
    const [doorData, setDoorData] = useState(null);

    const handleWinHingesChange = (e) => {
        setSelectedWinHinges(e.target.value);
        onChange(e.target.value);
    };

    return (
        <div className="a-container">
            <label disabled={disabled} htmlFor={id}>{label}</label>
            <select
                disabled={disabled}
                id={id}
                value={selectedWinHinges}
                onChange={handleWinHingesChange}
            >
                <option value="" disabled hidden>Select an option</option>
                <option value="Left">{selectedWinHinges === "Left" ? "Left ✔" : "Left"}</option>
                <option value="Right">{selectedWinHinges === "Right" ? "Right ✔" : "Right"}</option>
            </select>
        </div>
    );
};

export default WinHinges;
